import React, { useEffect, useRef, useState } from 'react'
import { academylist, driverlist, listvehicle, vehdriverattendancelist, vehicledriverattendance } from '../../../services/admin';
import Select from "react-select";
import { roleList, vehroutelist, vehtriplist } from '../../../services/master';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
export default function Transportattendance() {
    const [fdate, setFDate] = useState("");
    const [tdate, setTDate] = useState("");

    const [filterProduct, setFilterProduct] = useState([]);
    const [vehlist, setVenList] = useState([]);

    const [vlist, setVList] = useState([]);
    const [vehid, setVehID] = useState("");

    const [dlist, setDList] = useState([]);
    const [driverid, setDriverid] = useState("");

    const [rlist, setRList] = useState([]);
    const [routeid, setRouteID] = useState([]);
    const [vehRouteIds, setVehRouteIds] = useState([]); // routes of the selected vehicle (constrains the route picker)

    const [tlist, setTList] = useState([]);
    const [tripid, setTripID] = useState("");

    const [vdate, setVDate] = useState("");
    const [vtime, setVTime] = useState("");

    const [alist, setAList] = useState([]);
    const [acaid, setAcaID] = useState("");

    const [vstatus, setVStatus] = useState("1");

    const [remark, setRemark] = useState("");

    const [wlist, setWlist] = useState([]);
    const [wtype, setWType] = useState("");

    const columnDefs = [

        {
            headerName: "Date",
            field: "attendance_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div>
                        {moment(params.value).format("DD-MM-YYYY")}
                    </div>
                );
            }
        },
        {
            headerName: "Vehicle",
            field: "vehicle_no",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Name",
            field: "uname",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Username",
            field: "username",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Role",
            field: "role_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Driver Name",
            field: "worker_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Route",
            field: "vehroute_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Trip",
            field: "vehtrip_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Time",
            field: "attendance_time",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Present/Absent",
            field: "attend_status",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Remark",
            field: "remarks",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academy",
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];
    const location = useLocation();
    const [urllink, setUrllink] = useState("");

    useEffect(() => {
        const path = location.pathname.split("/")[2]; // Extracts 'allteacher' or 'leftteacherlist'
        setUrllink(path);
        setFDate(moment(new Date()).format("YYYY-MM-DD"));
        setTDate(moment(new Date()).format("YYYY-MM-DD"));
        setVDate(moment(new Date()).format("YYYY-MM-DD"));

        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAList(arr);
                }
            }
        });
        roleList().then((res) => {
            if (res.status === true) {
                setWlist(res.data);
            }
        });
        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);
                                listall(arr[0], moment(new Date()).format("YYYY-MM-DD"),
                                    moment(new Date()).format("YYYY-MM-DD"), "", "", "", "");
                            }
                        }

                    }
                }
            });
        } else {

            listall("", moment(new Date()).format("YYYY-MM-DD"),
                moment(new Date()).format("YYYY-MM-DD"), "", "", "", "");
        }
    }, [location.pathname])
    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
            listall(e, fdate, tdate, wtype, vehid, driverid, routeid);
        } else {
            setAcaID("");
            listall("", fdate, tdate, wtype, vehid, driverid, routeid);
        }
    }

    function handleDriver(e) {
        if (e !== null) {
            setDriverid(e);
            listall(acaid, fdate, tdate, wtype, vehid, e, routeid);

        } else {
            setDriverid("");
            listall(acaid, fdate, tdate, wtype, vehid, "", routeid);

        }
    }

    function handleVehicle(e) {
        if (e !== null) {
            setVehID(e);
            const sdata = vehlist.find((item) => item.id == e.value);
            if (sdata !== undefined) {
                let did = { value: sdata.driver_id, label: sdata.worker_name };
                setDriverid({ value: sdata.driver_id, label: sdata.worker_name });
                // A vehicle can serve multiple routes; attendance is for one route,
                // so auto-pick when there's only one, otherwise make the user choose.
                const ids = sdata.vehicle_route
                    ? String(sdata.vehicle_route).split(",").map((v) => v.trim()).filter((v) => v !== "")
                    : [];
                setVehRouteIds(ids);
                const single = ids.length === 1 ? ids[0] : "";
                setRouteID(single);
                listall(acaid, fdate, tdate, wtype, e, did, single);
            }
        } else {
            setVehID("");
            setDriverid("");
            setVehRouteIds([]);
            setRouteID("");
            listall(acaid, fdate, tdate, wtype, "", driverid, "");

        }
    }


    function listall(aid, fdte, tdte, ltype, veid, drid, rouid) {
        setVenList([]);
        setVList([]);
        setDList([]);
        setRList([]);
        setTList([]);
        setFilterProduct([]);
        setFDate(fdte);
        setTDate(tdte);
        setWType(ltype);
        setRouteID(rouid);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp.append("academy_id", aid.value);
        }
        temp.append("status", 1);
        listvehicle(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    setVenList(res.data.details);

                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].vehicle_no + " - " + res.data.details[i].worker_name,
                        });
                    }
                    setVList(arr);
                }
            }
        })

        driverlist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].worker_name + " - " + res.data.details[i].employee_id + " (" + res.data.details[i].username + ")",

                        });
                    }
                    setDList(arr);
                }
            }
        });

        vehroutelist(temp).then((res) => {
            if (res.status === true) {
                setRList(res.data);
            }
        });

        vehtriplist(temp).then((res) => {
            if (res.status === true) {
                setTList(res.data);
            }
        });


        const temp1 = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp1.append("academy_id", aid.value);
        }
        temp1.append("from_date", fdte);
        temp1.append("to_date", tdte);
        temp1.append("role_id", ltype);
        temp1.append("vehicle_id", veid ? veid.value : "");
        temp1.append("driver_id", drid ? drid.value : "");
        temp1.append("route_id", rouid);
        vehdriverattendancelist(temp1).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    arr = res.data.details.map((item) => ({
                        ...item,
                        attend_status: item.attend_status == 1 ? "Present" : "Absent",
                    }))
                }
                setFilterProduct(arr);
            }
        });

    }

    const [show, setShow] = useState(false)
    const [errmsg, setErrMsg] = useState("");

    function handleshow() {
        setShow(true)
        // setAcaID("");
        setVehID("");
        setVDate(moment(new Date()).format("YYYY-MM-DD"));
        setDriverid("");
        setRouteID("");
        setVehRouteIds([]);
        setTripID("");
        setRemark("");
        setErrMsg("");
    }

    function handleclose() {
        // setAcaID("");
        setVehID("");
        setVDate(moment(new Date()).format("YYYY-MM-DD"));
        setDriverid("");
        setRouteID("");
        setVehRouteIds([]);
        setTripID("");
        setRemark("");
        setErrMsg("");
        setShow(false)
    }


    function handleSave(e) {
        e.preventDefault();
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                setErrMsg("Please Select Academy");
                valid = "Please Select Academy";
            }
        } else {
            valid = "";
        }

        if (valid === "") {
            if (vehid !== "") {
                if (driverid !== "") {
                    if (routeid !== "") {
                        if (vdate !== "") {

                            const temp = new FormData();
                            temp.append("attendance_date", vdate);
                            temp.append("attendance_time", vtime);
                            temp.append("count", 1);
                            temp.append("id_" + [1], vehid.value);
                            temp.append("route_id", routeid);
                            temp.append("trip_id_" + [1], tripid);
                            temp.append("attend_status_" + [1], 1);
                            temp.append("remarks_" + [1], remark);
                            if (localStorage.getItem("Role") === "1" && acaid !== "") {
                                temp.append("academy_id", acaid.value);
                            }
                            vehicledriverattendance(temp).then((res) => {
                                if (res.status === true) {
                                    handleclose();
                                    toast.success(res.message);
                                    listall(acaid, fdate, tdate, wtype, vehid, driverid, routeid);
                                } else {
                                    setErrMsg(res.message);
                                }
                            });

                        } else {
                            setErrMsg("Please Select Date");
                        }
                    } else {
                        setErrMsg("Please Select Route");
                    }

                } else {
                    setErrMsg("Please Select Driver");
                }
            } else {
                setErrMsg("Please Select Vehicle");
            }
        }
    }
    const gridRef = useRef();

    function handleExport() {
        gridRef.current.api.exportDataAsCsv({
            fileName: 'Transport Report.csv',
            allColumns: true
        });
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5"> Driver Transport Attendance</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Transport</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">Driver Transport Attendance</li>

                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">

                    <div className="card">

                        <div className="card-body">
                            <div className="row">
                                {localStorage.getItem("Role") === "1" && (
                                    <div className="col-lg-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Select Academy
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Academy"
                                                value={acaid}
                                                options={alist}
                                                onChange={handleAcademy}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />

                                        </div>
                                    </div>
                                )}
                                <div className="col-lg-3">
                                    <label className="form-label">
                                        Role
                                        <span className="text-danger"> *</span>
                                    </label>
                                    <select
                                        className="default-select form-control wide"
                                        onChange={(e) => listall(acaid, fdate, tdate, e.target.value, vehid, driverid, routeid)}
                                        value={wtype}
                                    >
                                        <option value="" disabled>
                                            Select Role
                                        </option>

                                        {wlist
                                            .filter(item => [4, 5, 9].includes(item.id))
                                            .map(item => (
                                                <option value={item.id} key={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}

                                    </select>
                                </div>
                                <div className="col-lg-3">
                                    <label className="form-label">From Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        onChange={(e) =>
                                            listall(acaid, e.target.value, tdate, wtype, vehid, driverid, routeid)
                                        }
                                        value={fdate}
                                    />
                                </div>
                                <div className="col-lg-3">
                                    <label className="form-label">To Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        onChange={(e) =>
                                            listall(acaid, fdate, e.target.value, wtype, vehid, driverid, routeid)
                                        }
                                        value={tdate}
                                    />
                                </div>
                                <div className="col-lg-3">
                                    <label className="form-label">
                                        Vehicle
                                    </label>
                                    <Select
                                        className="default-select"
                                        placeholder="Select Vehicle"
                                        value={vehid}
                                        options={vlist}
                                        onChange={handleVehicle}
                                        isSearchable={true}
                                        isClearable
                                        hidden
                                    />
                                </div>
                                <div className="col-lg-3">
                                    <label className="form-label">
                                        Driver
                                    </label>
                                    <Select
                                        className="default-select"
                                        placeholder="Select Driver"
                                        value={driverid}
                                        options={dlist}
                                        onChange={handleDriver}
                                        isSearchable={true}
                                        isClearable
                                        hidden
                                    />
                                </div>



                                <div className="col-lg-3">
                                    <label className="form-label">
                                        Route
                                    </label>
                                    <select className="default-select form-control wide" onChange={(e) => listall(acaid, fdate, tdate, wtype, vehid, driverid, e.target.value)} value={routeid}>
                                        <option value="" disabled>
                                            Select Route
                                        </option>
                                        {(vehRouteIds.length > 0
                                            ? rlist.filter((item) => vehRouteIds.includes(String(item.id)))
                                            : rlist
                                        ).map((item) => {
                                            return (
                                                <option value={item.id} key={item.id}>
                                                    {item.vehroute_name}
                                                </option>
                                            );
                                        })

                                        }
                                    </select>
                                </div>

                                {urllink == "transportreport" && (
                                    <div className="col-lg-3">
                                        <div className="text-right mt-5">
                                            <a className="btn btn-success" onClick={handleExport} >Export</a>
                                        </div>
                                    </div>
                                )}
                                {/* {(localStorage.getItem("Role") === "1" || localStorage.getItem("Role") === "2" || localStorage.getItem("Role") === "7" || localStorage.getItem("Role") === "8")&& (
                                     <div className="col-lg-3">
                                     <div className="text-right mt-5">
                                         <a className="btn btn-success" onClick={handleshow} >Driver Attendance</a>
                                     </div>
                                 </div>
                                )} */}


                            </div>

                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="ag-theme-alpine ag-style mt-2">
                                        <AgGridReact
                                            ref={gridRef}
                                            columnDefs={columnDefs}
                                            rowData={filterProduct}
                                            pagination="true"
                                            paginationPageSize="10"
                                            sortingOrder={["asc", "desc"]}
                                            suppressDragLeaveHidesColumns={true}
                                        />
                                    </div>
                                    <Modal show={show} size="lg">
                                        <Modal.Header>
                                            <Modal.Title>Add Transport Attendance</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className="row">
                                                {localStorage.getItem("Role") === "1" && (
                                                    <div className="col-xl-6 col-sm-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                Select Academy
                                                                <span className="text-danger"> *</span>
                                                            </label>
                                                            <Select
                                                                className="default-select"
                                                                placeholder="Select Academy"
                                                                value={acaid}
                                                                options={alist}
                                                                onChange={handleAcademy}
                                                                isSearchable={true}
                                                                isClearable
                                                                hidden
                                                            />

                                                        </div>
                                                    </div>
                                                )}



                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-6">
                                                        <label className="form-label">
                                                            Trip<span className="text-danger"> *</span>
                                                        </label>
                                                        <select className="default-select form-control wide" onChange={(e) => setTripID(e.target.value)} value={tripid}>
                                                            <option value="" disabled>
                                                                Select Trip
                                                            </option>
                                                            {tlist.map((item) => {
                                                                return (
                                                                    <option value={item.id} key={item.id}>
                                                                        {item.vehtrip_name}
                                                                    </option>
                                                                );
                                                            })

                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-6">
                                                        <label className="form-label">
                                                            Date
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            onChange={(e) => setVDate(e.target.value)}
                                                            value={vdate}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-6">
                                                        <label className="form-label">
                                                            Attendance Time
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            onChange={(e) => setVTime(e.target.value)}
                                                            value={vtime}
                                                            className="default-select form-control wide"
                                                        >
                                                            <option value="" disabled>
                                                                Select Attendance Time
                                                            </option>
                                                            <option value="Morning">Morning</option>
                                                            <option value="Evening">Evening</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-6">
                                                        <label className="form-label">
                                                            Present/Absent
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            onChange={(e) => setVStatus(e.target.value)}
                                                            value={vstatus}
                                                            className="default-select form-control wide"
                                                        >
                                                            <option value="" disabled>
                                                                Select Present/Absent
                                                            </option>
                                                            <option value="0">Absent</option>
                                                            <option value="1">Present</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-6">
                                                        <label className="form-label">
                                                            Remark
                                                        </label>
                                                        <textarea rows="4" className="form-control" onChange={(e) => setRemark(e.target.value)} value={remark} placeholder='Enter Remark'></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <a className="btn btn-secondary" onClick={handleclose}>
                                                Close
                                            </a>
                                            <a className="btn btn-success" onClick={handleSave}>
                                                Submit
                                            </a>
                                        </Modal.Footer>
                                    </Modal>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
